import { gql } from "@apollo/client";

export const GET_SQUARETRADE_REPORT = gql`
  query GetSquareTradeReport($query: QueryInput, $ticket: TicketInput) {
    tickets(query: $query, ticket: $ticket) {
      tickets {
        _id
        id
        number
        status
        properties {
          claim_id
          claim_accepted_date
          received_date
        }
        assets {
          id
          asset_serial
          type
          properties {
            Make
            Model
          }
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
